import { lazyLoadWithFallback } from "./lazyLoadFallback.js";
const iconMap = {
  Badge: lazyLoadWithFallback(() => import("../../chunks/badge-BVB9EAmp.js")),
  Bag: lazyLoadWithFallback(() => import("../../chunks/bag-C80G7OxY.js")),
  Bank: lazyLoadWithFallback(() => import("../../chunks/bank-DnyAOLFG.js")),
  Bell: lazyLoadWithFallback(() => import("../../chunks/bell-10APDGck.js")),
  Bookmark: lazyLoadWithFallback(() => import("../../chunks/bookmark-blDIcQRX.js")),
  Business: lazyLoadWithFallback(() => import("../../chunks/business-a899Q9dt.js")),
  Calendar: lazyLoadWithFallback(() => import("../../chunks/calendar-BLzFkcpp.js")),
  CartAdd: lazyLoadWithFallback(() => import("../../chunks/cart-add-CUqXaPrb.js")),
  CartAdded: lazyLoadWithFallback(() => import("../../chunks/cart-added-CX8Q8ub5.js")),
  CartHeart: lazyLoadWithFallback(() => import("../../chunks/cart-heart-CAaE8sWb.js")),
  CartRefresh: lazyLoadWithFallback(() => import("../../chunks/cart-refresh-CUadt5S8.js")),
  CartRemove: lazyLoadWithFallback(() => import("../../chunks/cart-remove-DhYSX76Y.js")),
  Cart: lazyLoadWithFallback(() => import("../../chunks/cart-CMx6daxl.js")),
  Case: lazyLoadWithFallback(() => import("../../chunks/case-D7y0hvay.js")),
  Cash: lazyLoadWithFallback(() => import("../../chunks/cash-DZCc0bGw.js")),
  Chat: lazyLoadWithFallback(() => import("../../chunks/chat-DJj67Fy8.js")),
  Check1: lazyLoadWithFallback(() => import("../../chunks/check-1-WJkFrfFT.js")),
  Check2: lazyLoadWithFallback(() => import("../../chunks/check-2-DN7jCj3Q.js")),
  Checklist: lazyLoadWithFallback(() => import("../../chunks/checklist-BzKWxwBl.js")),
  ChevronDown: lazyLoadWithFallback(() => import("../../chunks/chevron-down-C5IcbPCD.js")),
  ChevronLeft: lazyLoadWithFallback(() => import("../../chunks/chevron-left-Ck02cnRH.js")),
  ChevronRight: lazyLoadWithFallback(() => import("../../chunks/chevron-right-Q4I7F8nt.js")),
  ChevronUp: lazyLoadWithFallback(() => import("../../chunks/chevron-up-CAig4HiF.js")),
  Clock: lazyLoadWithFallback(() => import("../../chunks/clock-CpVIV7FM.js")),
  Code: lazyLoadWithFallback(() => import("../../chunks/code-qVBCcSQm.js")),
  ComputerSmiling: lazyLoadWithFallback(() => import("../../chunks/computer-smiling-kccpthow.js")),
  Contacts: lazyLoadWithFallback(() => import("../../chunks/contacts-DdVckN_Y.js")),
  CreditCardSafe: lazyLoadWithFallback(() => import("../../chunks/credit-card-safe-DFQAehiV.js")),
  CreditCard: lazyLoadWithFallback(() => import("../../chunks/credit-card-BplyPO6s.js")),
  Diamond: lazyLoadWithFallback(() => import("../../chunks/diamond-B26on1zC.js")),
  Discount: lazyLoadWithFallback(() => import("../../chunks/discount-BsIeGaee.js")),
  Document: lazyLoadWithFallback(() => import("../../chunks/document-Be3jpwmT.js")),
  Drag: lazyLoadWithFallback(() => import("../../chunks/drag-Ch89CSko.js")),
  DropPlus: lazyLoadWithFallback(() => import("../../chunks/drop-plus-C-b5BH0X.js")),
  Email: lazyLoadWithFallback(() => import("../../chunks/email-_iRJGjZE.js")),
  Employee: lazyLoadWithFallback(() => import("../../chunks/employee-DvT-y_GW.js")),
  Error: lazyLoadWithFallback(() => import("../../chunks/error-BpZ6f_Er.js")),
  Exit: lazyLoadWithFallback(() => import("../../chunks/exit-Bf5KCzRe.js")),
  EyeCheck: lazyLoadWithFallback(() => import("../../chunks/eye-check-B8PuqQiq.js")),
  EyeCrossed: lazyLoadWithFallback(() => import("../../chunks/eye-crossed-C-td90p8.js")),
  EyeLeaf: lazyLoadWithFallback(() => import("../../chunks/eye-leaf-9ZsR0PZj.js")),
  EyeTest1: lazyLoadWithFallback(() => import("../../chunks/eye-test-1-DkTyt93m.js")),
  EyeTest2: lazyLoadWithFallback(() => import("../../chunks/eye-test-2-Dw9YBKft.js")),
  EyeTest3: lazyLoadWithFallback(() => import("../../chunks/eye-test-3-CK_0hTLQ.js")),
  EyeTestCar: lazyLoadWithFallback(() => import("../../chunks/eye-test-car-BYEzpezR.js")),
  EyeTestCard: lazyLoadWithFallback(() => import("../../chunks/eye-test-card-BJTLotJB.js")),
  EyeTestContactLens: lazyLoadWithFallback(
    () => import("../../chunks/eye-test-contact-lens-u_LITtKJ.js")
  ),
  EyeTestGlasses: lazyLoadWithFallback(() => import("../../chunks/eye-test-glasses-IBToOGwc.js")),
  Eye: lazyLoadWithFallback(() => import("../../chunks/eye-Bt3EPNe_.js")),
  HearingTest: lazyLoadWithFallback(() => import("../../chunks/hearing-test-BOlGd-iL.js")),
  FileCheck: lazyLoadWithFallback(() => import("../../chunks/file-check-TuK6h4gb.js")),
  FileDownload: lazyLoadWithFallback(() => import("../../chunks/file-download-VtUHX96k.js")),
  FileUpload: lazyLoadWithFallback(() => import("../../chunks/file-upload-Bisouud-.js")),
  Filter: lazyLoadWithFallback(() => import("../../chunks/filter-CYFo6EcL.js")),
  Frames1: lazyLoadWithFallback(() => import("../../chunks/frames-1-DVX1EonM.js")),
  Frames2: lazyLoadWithFallback(() => import("../../chunks/frames-2-C7jn2kp4.js")),
  Franchise: lazyLoadWithFallback(() => import("../../chunks/franchise-BSli-zQi.js")),
  Heart1: lazyLoadWithFallback(() => import("../../chunks/heart-1-C_7KBTgH.js")),
  Heart2: lazyLoadWithFallback(() => import("../../chunks/heart-2-YeLwTpt8.js")),
  Image: lazyLoadWithFallback(() => import("../../chunks/image-jc84wt0m.js")),
  Info: lazyLoadWithFallback(() => import("../../chunks/info-DzuQt_QD.js")),
  InfoFilled: lazyLoadWithFallback(() => import("../../chunks/info-filled-Digg8ngG.js")),
  LensDrop: lazyLoadWithFallback(() => import("../../chunks/lens-drop-DHJ68-hi.js")),
  Lens: lazyLoadWithFallback(() => import("../../chunks/lens-DT6E7iM7.js")),
  List: lazyLoadWithFallback(() => import("../../chunks/list-BQBKTpVD.js")),
  Location: lazyLoadWithFallback(() => import("../../chunks/location-B_uZWaAp.js")),
  Lock: lazyLoadWithFallback(() => import("../../chunks/lock-CAPBNt2v.js")),
  Measure: lazyLoadWithFallback(() => import("../../chunks/measure-CpSLWf4r.js")),
  Menu: lazyLoadWithFallback(() => import("../../chunks/menu-DdKr1DtH.js")),
  MinusBig: lazyLoadWithFallback(() => import("../../chunks/minus-big-dM9EMFe3.js")),
  MinusSmall: lazyLoadWithFallback(() => import("../../chunks/minus-small-zZWTnZJO.js")),
  New: lazyLoadWithFallback(() => import("../../chunks/new-BMyth2tP.js")),
  Newsletter: lazyLoadWithFallback(() => import("../../chunks/newsletter-BY2eZZKd.js")),
  Newspaper: lazyLoadWithFallback(() => import("../../chunks/newspaper-ChpOYr0F.js")),
  Note: lazyLoadWithFallback(() => import("../../chunks/note-G-GQoPEY.js")),
  PackageMoving: lazyLoadWithFallback(() => import("../../chunks/package-moving-D9gbVT8a.js")),
  Package: lazyLoadWithFallback(() => import("../../chunks/package-bPX0L4EJ.js")),
  Pause: lazyLoadWithFallback(() => import("../../chunks/pause-o5Kd4-Yv.js")),
  Pencil: lazyLoadWithFallback(() => import("../../chunks/pencil-BNbZOY-c.js")),
  PhoneChat: lazyLoadWithFallback(() => import("../../chunks/phone-chat-2EhrqvxL.js")),
  PhoneFlash: lazyLoadWithFallback(() => import("../../chunks/phone-flash-g-GahrXF.js")),
  Phone: lazyLoadWithFallback(() => import("../../chunks/phone-BNmBMSPg.js")),
  Pin1: lazyLoadWithFallback(() => import("../../chunks/pin-1-DidKTxUT.js")),
  Pin2: lazyLoadWithFallback(() => import("../../chunks/pin-2-BlmUcPHa.js")),
  Play: lazyLoadWithFallback(() => import("../../chunks/play-BLbEeLpr.js")),
  PlusBig: lazyLoadWithFallback(() => import("../../chunks/plus-big-I3EvxK4P.js")),
  PlusSmall: lazyLoadWithFallback(() => import("../../chunks/plus-small-Buua1z2A.js")),
  Print: lazyLoadWithFallback(() => import("../../chunks/print-DRRL2xs6.js")),
  Redo: lazyLoadWithFallback(() => import("../../chunks/redo-BlV4N9S7.js")),
  Refresh: lazyLoadWithFallback(() => import("../../chunks/refresh-Bdw-c9Ux.js")),
  Reschedule: lazyLoadWithFallback(() => import("../../chunks/reschedule-DnJSfVeT.js")),
  Search: lazyLoadWithFallback(() => import("../../chunks/search-BMQoCKyU.js")),
  Send: lazyLoadWithFallback(() => import("../../chunks/send-fRAaGkMg.js")),
  Service1: lazyLoadWithFallback(() => import("../../chunks/service-1-DLa6lFSz.js")),
  Service2: lazyLoadWithFallback(() => import("../../chunks/service-2-C9SHnU1-.js")),
  Shades1: lazyLoadWithFallback(() => import("../../chunks/shades-1-Cl459Tvr.js")),
  Shades2: lazyLoadWithFallback(() => import("../../chunks/shades-2-Bj-mqpM-.js")),
  Share: lazyLoadWithFallback(() => import("../../chunks/share-CCasJ4gV.js")),
  Shrink: lazyLoadWithFallback(() => import("../../chunks/shrink-CzfjVUz4.js")),
  Star1: lazyLoadWithFallback(() => import("../../chunks/star-1-Di4_wVSK.js")),
  Star2: lazyLoadWithFallback(() => import("../../chunks/star-2-yk-gP30Q.js")),
  StoreCart: lazyLoadWithFallback(() => import("../../chunks/store-cart-BI88hzT7.js")),
  Store: lazyLoadWithFallback(() => import("../../chunks/store-Dqd2Hgbf.js")),
  Subscription: lazyLoadWithFallback(() => import("../../chunks/subscription-CMwjbiEX.js")),
  Sun: lazyLoadWithFallback(() => import("../../chunks/sun-6HGmkTtb.js")),
  Target: lazyLoadWithFallback(() => import("../../chunks/target-7bEBKBe6.js")),
  Thrashcan: lazyLoadWithFallback(() => import("../../chunks/thrashcan-Bpt5KTsS.js")),
  ThreeSixtyView: lazyLoadWithFallback(() => import("../../chunks/three-sixty-view-DKfkiIk9.js")),
  Truck: lazyLoadWithFallback(() => import("../../chunks/truck-BTHdj2CD.js")),
  Undo: lazyLoadWithFallback(() => import("../../chunks/undo-Bwhpg9qy.js")),
  UserCheck: lazyLoadWithFallback(() => import("../../chunks/user-check-BMOWITLr.js")),
  UserPencil: lazyLoadWithFallback(() => import("../../chunks/user-pencil-1qeOw1l2.js")),
  UserSearch: lazyLoadWithFallback(() => import("../../chunks/user-search-Cd8ged7Y.js")),
  User: lazyLoadWithFallback(() => import("../../chunks/user-BlDjtlmN.js")),
  VirtualTryOn: lazyLoadWithFallback(() => import("../../chunks/virtual-try-on-3tb7-U4u.js")),
  VideoCall: lazyLoadWithFallback(() => import("../../chunks/video-call-D6i245Jg.js")),
  Warning: lazyLoadWithFallback(() => import("../../chunks/warning-vev2qxgU.js")),
  Warranty: lazyLoadWithFallback(() => import("../../chunks/warranty-C6K-8TWl.js")),
  Wheelchair: lazyLoadWithFallback(() => import("../../chunks/wheelchair-Bx5CTGOh.js")),
  XBig: lazyLoadWithFallback(() => import("../../chunks/x-big-COjFoRIg.js")),
  XSmall: lazyLoadWithFallback(() => import("../../chunks/x-small-Dr2pdTX7.js")),
  ZoomIn: lazyLoadWithFallback(() => import("../../chunks/zoom-in-D2KeRBFn.js")),
  ZoomOut: lazyLoadWithFallback(() => import("../../chunks/zoom-out-bBKuT_nb.js"))
};
function getIconByName(name) {
  const IconComponent = iconMap[name];
  if (!IconComponent) {
    throw new Error(`Icon ${name} does not exist`);
  }
  return IconComponent;
}
export {
  getIconByName,
  iconMap
};
